import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export type TranscriptRole = 'user' | 'agent';

export interface TranscriptMessage {
  id: string;
  role: TranscriptRole;
  text: string;
  timestamp: string;
  isInterim?: boolean;
}

@customElement('cp-call-transcript')
export class CpCallTranscript extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Array }) messages: TranscriptMessage[] = [];

  updated(changedProperties: Map<string, unknown>): void {
    if (changedProperties.has('messages')) {
      this._scrollToBottom();
    }
  }

  private _scrollToBottom(): void {
    requestAnimationFrame(() => {
      const container = this.querySelector('.cp-call-transcript__list');
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    });
  }

  private _formatTime(timestamp: string): string {
    try {
      const date = new Date(timestamp);
      return date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    } catch {
      return '';
    }
  }

  render() {
    if (this.messages.length === 0) {
      return nothing;
    }

    return html`
      <div class="cp-call-transcript">
        <h3 class="cp-call-transcript__title">Transkript</h3>
        <div class="cp-call-transcript__list">
          ${this.messages.map(msg => html`
            <div class="cp-call-transcript__entry cp-call-transcript__entry--${msg.role}${msg.isInterim ? ' cp-call-transcript__entry--interim' : ''}">
              <div class="cp-call-transcript__header">
                <span class="cp-call-transcript__role cp-call-transcript__role--${msg.role}">
                  ${msg.role === 'user' ? 'Du' : 'Agent'}
                </span>
                <span class="cp-call-transcript__time">${this._formatTime(msg.timestamp)}</span>
              </div>
              <p class="cp-call-transcript__text">${msg.text}</p>
            </div>
          `)}
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-call-transcript': CpCallTranscript;
  }
}
